
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.677 2.538H3.323C2.593 2.538 2 3.13 2 3.86v4.355c0 .73.593 1.323 1.323 1.323h4.354C8.407 9.538 9 8.945 9 8.215V3.86c0-.729-.593-1.322-1.323-1.322zM7.677 11.538H3.323c-.73 0-1.323.593-1.323 1.322v4.355c0 .73.593 1.323 1.323 1.323h4.354c.73 0 1.323-.593 1.323-1.323V12.86c0-.729-.593-1.322-1.323-1.322zM16.677 2.538h-4.354c-.73 0-1.323.593-1.323 1.322v4.355c0 .73.593 1.323 1.322 1.323h4.355c.73 0 1.323-.593 1.323-1.323V3.86c0-.729-.593-1.322-1.323-1.322zM16.677 11.538h-4.354c-.73 0-1.323.593-1.323 1.322v4.355c0 .73.593 1.323 1.322 1.323h4.355c.73 0 1.323-.593 1.323-1.323V12.86c0-.729-.593-1.322-1.323-1.322z","fill":"#348EF6"}})])
          )
        }
      }
    